import React, { lazy, Suspense } from "react";
import { useRoutes } from "react-router-dom";
import GenerateAppRoutes from "routes/GenerateAppRoutes";
import { createRoutesFromChildren } from "use-react-router-breadcrumbs";
const PageLoading = lazy(() => import("./pages/PageLoading"));

function App() {
	const AppRoutes = GenerateAppRoutes();
	const appRouteObjects = createRoutesFromChildren(AppRoutes);
	const GeneratedRoutes = useRoutes(appRouteObjects);
	return GeneratedRoutes;
}

export default App;

